import { useEventListener } from '@vueuse/core';
import { ref } from 'vue';

const clamp = (v: number, [min, max] = [0, 1]) =>
  v < min ? min : v > max ? max : v;

export default function useSeek(
  seekRef: Ref<HTMLDivElement | undefined>,
  updateProgress: (v?: number, options?: { duration: number }) => void
) {
  const seeking = ref(false);

  function setProgess(
    e: MouseEvent | TouchEvent,
    { duration = 0 }: { duration?: number } = {}
  ) {
    const el = seekRef.value;
    if (!el) return;

    const { left, width } = el.getBoundingClientRect();
    const clientX = 'clientX' in e ? e.clientX : e.touches[0]?.clientX;
    const newProgress = clamp((clientX - left) / width);

    updateProgress(newProgress, { duration });
  }

  const endSeek = (e: MouseEvent) => {
    seeking.value = false;
    setProgess(e, { duration: 0.2 });
    document.body.style.userSelect = '';

    window.removeEventListener('mouseup', endSeek);
    window.removeEventListener('touchend', endSeek);
    window.removeEventListener('mousemove', moveSeek);
    window.removeEventListener('touchmove', moveSeek);
  };

  const moveSeek = (e: MouseEvent | TouchEvent) => {
    if (seeking.value) {
      setProgess(e, { duration: 0 });
    }
  };

  const startSeek = ({ touch = false } = {}) => {
    document.body.style.userSelect = 'none';
    seeking.value = true;
    window.addEventListener(touch ? 'touchend' : 'mouseup', endSeek);
    window.addEventListener('mousemove', moveSeek);
    window.addEventListener('touchmove', moveSeek);
  };

  useEventListener(seekRef, 'mousedown', () => startSeek());
  useEventListener(seekRef, 'touchstart', () => startSeek({ touch: true }));
}
